var map = {
	"./Logo_Sparkasse_rot.png": "b0d7",
	"./banner.png": "f6bf",
	"./fonts/SparkasseHead_web_Rg.woff": "fd27",
	"./fonts/Sparkasse_web_Bd.woff": "d578",
	"./fonts/Sparkasse_web_Lt.woff": "1761",
	"./fonts/Sparkasse_web_Rg.woff": "12f6",
	"./logo.svg": "a687",
	"./spk__arrow-right.svg": "8685"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6be2";